/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Addr_Sugg_UnmatchedInputs */

const cs_addr_sugg_unmatched = /** @type {(inputs: Addr_Sugg_UnmatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bez návrhu (RÚIAN nenašel jistou shodu): ${i?.fields}`)
};

const en_addr_sugg_unmatched = /** @type {(inputs: Addr_Sugg_UnmatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No suggestion (no confident RÚIAN match): ${i?.fields}`)
};

/**
* | output |
* | --- |
* | "No suggestion (no confident RÚIAN match): {fields}" |
*
* @param {Addr_Sugg_UnmatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_unmatched = /** @type {((inputs: Addr_Sugg_UnmatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_UnmatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_unmatched(inputs)
	return cs_addr_sugg_unmatched(inputs)
});